import { useState, useEffect } from 'react'
import Article, { ARTICLE_ID } from '@components/html/Article'
// import createExcrptMaintainingWords from '@utils/string/excerptMaintainingWords'
import useT from '@hooks/useTranslation'

const excerptConfig = {
    mobileMaxChars: 120,
    startDelimiter: '<p>',
    endDelimiter: '</p>',
    whitespaceOffset: 0,
}

const textStyle = {
    lineHeight: 1.6,
}

const linkStyle = {
    color: 'var(--teal)',
    paddingLeft: 6,
}

export default function useSeoArticle (article, image, imageAlt, dontUseExcerpt = false) {
    const [onMobile, setOnMobile] = useState(true)
    const [excerpt, restOfText] = createExcerpt(article, (onMobile || dontUseExcerpt), excerptConfig)

    useEffect(() => {
        if (window.innerWidth >= 800) {
            setOnMobile(false)
        }
    }, [])

    if (!restOfText) return []

    return [
        excerpt ? <Excerpt excerpt={excerpt} style={textStyle} /> : undefined,
        <>
            <Article article={restOfText} style={textStyle} />
            { image && <ArticleImage image={image} alt={imageAlt} /> }
        </>,
    ]
}

function createExcerpt (article, onMobile,
    { startDelimiter, endDelimiter, whitespaceOffset} = {}) { // mobileMaxChars

    if (!article) return []

    const excerptHtmlStartIdx = article.indexOf(startDelimiter)
    const excerptStartIdx = excerptHtmlStartIdx + startDelimiter.length
    const excerptEndIdx = article.indexOf(endDelimiter, excerptStartIdx) + whitespaceOffset
    const excerptHtmlEndIdx = excerptEndIdx + endDelimiter.length

    if (excerptStartIdx !== -1 && excerptEndIdx !== -1) {
        if (onMobile) {
            return ['', article] // <- currently, do not use excerpt at all
        }

        const excerpt = article.slice(excerptStartIdx, excerptEndIdx)

        // const isTooLong = onMobile && (excerpt.length > mobileMaxChars)
        // if (isTooLong) {
        //     return [
        //         createExcrptMaintainingWords(excerpt, mobileMaxChars),
        //         article,
        //     ]

        // } else {
            return [
                excerpt,
                article.slice(0, excerptHtmlStartIdx) + article.slice(excerptHtmlEndIdx),
            ]
        //}
    }

    return []
}

function Excerpt ({ excerpt, style }) {
    const czytajWiecej = useT('Czytaj więcej')
    return (
        <p className="container">
            <span dangerouslySetInnerHTML={{ __html: excerpt }} style={style} />
            <a href={`#${ARTICLE_ID}`} style={linkStyle}>{czytajWiecej}</a>
        </p>
    )
}

function ArticleImage ({ image, alt = '' }) {
    if (!image) return null
    return <img
        alt={alt}
        src={`/api/photos/seo/article/${image}`}
        style={{display:'block',margin:'20px auto',maxWidth:'100%',width:500}}
        title={alt}
    />
}